import { render, staticRenderFns } from "./GlobalGraph.vue?vue&type=template&id=37fa2d16&scoped=true"
import script from "./GlobalGraph.vue?vue&type=script&lang=js"
export * from "./GlobalGraph.vue?vue&type=script&lang=js"
import style0 from "./GlobalGraph.vue?vue&type=style&index=0&id=37fa2d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fa2d16",
  null
  
)

export default component.exports